var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import InputLabel from '../InputLabel';
var STYLE_NAMESPACE = 'vcp-checked-input';
export var InputType;
(function (InputType) {
    InputType["Checkbox"] = "checkbox";
    InputType["Radio"] = "radio";
})(InputType || (InputType = {}));
var CheckedInputBase = function (_a) {
    var isDisabled = _a.isDisabled, label = _a.label, onChange = _a.onChange, isChecked = _a.isChecked, _b = _a.shape, shape = _b === void 0 ? 'square' : _b, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, name = _a.name, value = _a.value, type = _a.type, isIndeterminate = _a.isIndeterminate, _d = _a.labelPosition, labelPosition = _d === void 0 ? 'right' : _d;
    var inputRef = React.useRef(null);
    React.useEffect(function () {
        if (inputRef.current) {
            inputRef.current.indeterminate = !!isIndeterminate;
        }
    }, [isIndeterminate]);
    var checkedInputId = React.useMemo(function () { return "".concat(STYLE_NAMESPACE, "-").concat(uuidv4()); }, []);
    var memoProps = React.useMemo(function () { return ({
        className: classNames("".concat(STYLE_NAMESPACE, "-input"), shape === 'round' && "".concat(STYLE_NAMESPACE, "-input-round"), isIndeterminate && "".concat(STYLE_NAMESPACE, "-input-indeterminate")),
    }); }, [shape, isIndeterminate]);
    return (React.createElement("div", { className: STYLE_NAMESPACE, tabIndex: readOnly ? undefined : 0, role: "button" },
        React.createElement("input", __assign({ id: checkedInputId, type: type, onChange: onChange, checked: isChecked, disabled: isDisabled, readOnly: readOnly, name: name, tabIndex: -1, value: value, ref: inputRef }, memoProps)),
        React.createElement(InputLabel, { label: label, inputId: checkedInputId, labelPosition: labelPosition })));
};
export default React.memo(CheckedInputBase);
